import { render, staticRenderFns } from "./LegacyEntryTag.vue?vue&type=template&id=c6f7b6ea&scoped=true&"
import script from "./LegacyEntryTag.vue?vue&type=script&lang=js&"
export * from "./LegacyEntryTag.vue?vue&type=script&lang=js&"
import style0 from "./LegacyEntryTag.vue?vue&type=style&index=0&id=c6f7b6ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f7b6ea",
  null
  
)

export default component.exports